import { MarkdownDocPage } from "@/components/MarkdownDocPage";
import { createFileRoute } from "@tanstack/react-router";
import salesMd from "../../../docs/phase1-sales-guide.md?raw";

export const Route = createFileRoute("/docs/phase1/sales")({
	component: () => <MarkdownDocPage source={salesMd} />,
});
